// extracted by mini-css-extract-plugin
export default {"primary-font":"AdminConsole_primary-font__aa8LX","secondary-font":"AdminConsole_secondary-font__M3rkx","virtual-code":"AdminConsole_virtual-code__ptFUh"};